const SCROLL_EVENT_NAME = 'scroll';

export default class ScrollAdapter {
    private scrollContainer: HTMLDivElement;
    private scrollListeners: (() => void)[] = [];
    private scrollContainerChangedListeners: ((scrollContainer: HTMLDivElement) => void)[] = [];
    private cachedElementPosition: number = NaN;

    setScrollContainer(scrollContainer: HTMLDivElement) {
        if (this.scrollContainer) {
            this.scrollContainer.removeEventListener(SCROLL_EVENT_NAME, this.onScroll);
        }

        this.scrollContainer = scrollContainer;
        this.scrollContainerChangedListeners.forEach(listener => listener(this.scrollContainer));

        if (this.scrollContainer) {
            this.scrollContainer.addEventListener(SCROLL_EVENT_NAME, this.onScroll);
        }
    }

    addScrollEventListener(listener: () => void) {
        if (this.scrollListeners.indexOf(listener) < 0) {
            this.scrollListeners.push(listener);
        }
    }

    removeScrollEventListener(listener: () => void) {
        let index = this.scrollListeners.indexOf(listener);

        if (index >= 0) {
            this.scrollListeners.splice(index, 1);
        }
    }

    addScrollContainerChangedListener(listener: (scrollContainer: HTMLDivElement) => void) {
        if (this.scrollContainerChangedListeners.indexOf(listener) < 0) {
            this.scrollContainerChangedListeners.push(listener);
        }
    }

    removeScrollContainerChangedListener(listener: (scrollContainer: HTMLDivElement) => void) {
        let index = this.scrollContainerChangedListeners.indexOf(listener);

        if (index >= 0) {
            this.scrollContainerChangedListeners.splice(index, 1);
        }
    }

    getScrollContainer(): HTMLDivElement {
        return this.scrollContainer;
    }

    saveElementPosition(element: HTMLElement) {
        if (element && this.scrollContainer) {
            this.cachedElementPosition = element.offsetTop - this.scrollContainer.scrollTop;
        } else {
            this.cachedElementPosition = NaN;
        }
    }

    restoreElementPosition(element: HTMLElement) {
        if (
            element &&
            this.scrollContainer &&
            (!isNaN(this.cachedElementPosition) && typeof this.cachedElementPosition === 'number')
        ) {
            this.scrollContainer.scrollTop = element.offsetTop - this.cachedElementPosition;
            this.cachedElementPosition = NaN;
        }
    }

    private onScroll = () => {
        this.scrollListeners.forEach(listener => listener());
    };
}
